import { ChevronDownIcon } from "./icons";

export default function FaqSection({ items }) {
  return (
    <section className="kn-section">
      <div className="kn-container">
        <div className="kn-faq-heading" data-reveal="up">
          <span className="kn-eyebrow">Preguntas frecuentes</span>
          <h2 className="kn-section-title">Resolvemos sus dudas</h2>
        </div>
        <div className="kn-faq-wrap" data-reveal-group>
          {items.map(({ question, answer }, index) => (
            <details key={question} open={index === 0} data-reveal="up">
              <summary>
                <span>{question}</span>
                <ChevronDownIcon className="kn-icon kn-faq-chevron" />
              </summary>
              {answer.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
